import LinePercentageIcon from 'LuxKit/Icons/line/LinePercentageIcon'
import TourDarkSuccessPromotionLabel from './TourDarkSuccessPromotionLabel'
import config from 'constants/config'
import { getTourCampaignTier, isTourCampaignActive } from 'constants/tours'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'

interface Props {
  className?: string
  campaignTags?: Array<string>
}

function TourCampaignTravelTagLabel({ campaignTags, className }: Props) {
  const intl = useIntl()
  const region = useAppSelector(state => state.geo.currentRegionCode)

  if (!isTourCampaignActive(region, config.BRAND)) {
    return null
  }

  const tier = getTourCampaignTier(campaignTags, intl)

  if (!tier) {
    return null
  }

  return <TourDarkSuccessPromotionLabel className={className} icon={<LinePercentageIcon />} variant="default">{tier.tag}</TourDarkSuccessPromotionLabel>
}

export default TourCampaignTravelTagLabel
